/* src/app/modules/coils/components/coil-information/coil-Information.component.scss */
[screen-phone] :host-context .replacement-part-visibility {
  display: contents;
}
[screen-phone] :host-context .replacement-part-label {
  margin-top: 0.5rem;
  grid-row: 3;
}
[screen-phone] :host-context .replacement-part-number {
  grid-row: 4;
}
[screen-phone] :host-context .relevant-information-label {
  grid-row: 5;
  margin-top: 0.5rem;
}
[screen-phone] :host-context .further-information-label {
  grid-row: 6;
}
[screen-phone] :host-context .label-coil-material-number {
  grid-row: 2;
}
[screen-phone] :host-context .label-coil-serial-number {
  grid-column: 2;
  grid-row: 2;
}
[screen-phone] :host-context .replacement {
  visibility: hidden;
}
[screen-phone] :host-context .replacement + .relevant-information-label {
  grid-column: 1;
  grid-row: 3;
}
.replacement {
  visibility: hidden;
}
.replacement + .relevant-information-label {
  grid-column: 3;
  grid-row: 1;
}
@media (min-width: 1025px) and (max-width: 1350px) {
  .replacement-part-visibility {
    display: contents;
  }
  .replacement-part-label {
    margin-top: 0.5rem;
    grid-row: 3;
  }
  .replacement-part-number {
    grid-row: 4;
  }
  .relevant-information-label {
    grid-row: 5;
    margin-top: 0.5rem;
  }
  .further-information-label {
    grid-row: 6;
  }
  .label-coil-material-number {
    grid-row: 2;
  }
  .label-coil-serial-number {
    grid-column: 2;
    grid-row: 2;
  }
  .replacement {
    visibility: hidden;
  }
  .replacement + .relevant-information-label {
    grid-column: 1;
    grid-row: 3;
  }
}
@media (min-width: 1351px) and (max-width: 1655px) {
  .relevant-information-label {
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.coil-info-table {
  border-spacing: 40px 0px;
  margin-left: -40px;
}
.coil-info-table tr:first-child td {
  color: var(--text-secondary);
}
.information-header {
  margin-top: 1rem;
}
.replacement-part {
  display: flex;
  background-color: #ebebeb;
  border: 2px solid #ebebeb;
  padding: 2px 8px;
  border-radius: 15px;
  width: -moz-fit-content;
  width: fit-content;
}
.replacement-part sh-text {
  align-items: center;
  display: inline-flex;
  text-decoration: underline;
  margin-left: 0.5rem;
  cursor: pointer;
}
.relevant-info {
  display: flex;
}
.information-grid {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 7rem) 10rem 0rem;
  grid-template-rows: 1.5rem;
}
/*# sourceMappingURL=coil-Information.component.css.map */
